import workout_goals from "./goal.svg";
import height from "./height.svg";
import weight from "./weight.svg";
import diet_types from "./meals.svg";
import age from "./age.svg";

export default { workout_goals, height, weight, diet_types, age };
